import type { ReactElement } from 'react';

import type { DrupalNode } from '@commons/types/drupal';

import ArticleNode from './Article';
import CampaignPageNode from './CampaignPage';
import CaseStudyNode from './CaseStudy';
import EventNode from './Event';
import FAQNode from './FAQ';
import IntelligenceNode from './Intelligence';
import MemberNode from './Member';
import PageNode from './Page';
import PodcastNode from './Podcast';
import PressReleaseNode from './PressRelease';
import TestimonialNode from './Testimonial';
import WebinarNode from './Webinar';
import WhitePaperNode from './WhitePaper';

/**
 * Enum of all available node bundles.
 *
 * Makes it easier to read and edit the bundles.
 */

export enum NODE_BUNDLE {
  Page = 'landing_page',
  CampaignPage = 'campaign_page',
  FAQ = 'faq',
  Testimonial = 'testimonial',
  Intelligence = 'intelligence',
  Member = 'member',
  Article = 'article',
  PressRelease = 'press_release',
  CaseStudy = 'case_study',
  Event = 'event',
  Podcast = 'podcast',
  WhitePaper = 'white_paper',
  Webinar = 'webinar',
}

/**
 * Type definition for a node component.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Node = (props: DrupalNode & any) => ReactElement;

/**
 * Type definition for a nodes factory.
 *
 * It uses `string` instead of the enums as key, so that each site can have its own nodes without type issue.
 */

export type NodesFactory = Record<string, Node>;

/**
 * Factory of all available nodes.
 */

export const nodes: NodesFactory = {
  [NODE_BUNDLE.Page]: PageNode,
  [NODE_BUNDLE.CampaignPage]: CampaignPageNode,
  [NODE_BUNDLE.FAQ]: FAQNode,
  [NODE_BUNDLE.Article]: ArticleNode,
  [NODE_BUNDLE.PressRelease]: PressReleaseNode,
  [NODE_BUNDLE.Testimonial]: TestimonialNode,
  [NODE_BUNDLE.Intelligence]: IntelligenceNode,
  [NODE_BUNDLE.Member]: MemberNode,
  [NODE_BUNDLE.CaseStudy]: CaseStudyNode,
  [NODE_BUNDLE.Event]: EventNode,
  [NODE_BUNDLE.Podcast]: PodcastNode,
  [NODE_BUNDLE.WhitePaper]: WhitePaperNode,
  [NODE_BUNDLE.Webinar]: WebinarNode,
};
